module.exports = __webpack_public_path__ + "media/images/emblems/Ferpicloz-coat_of_arms-e888db948557a2c5bce7c6472a6cfdba.svg";